import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import SP from 'dyzio-shared-components/lib/reports/super-report';

const SuperReport = props => {
  const { match: { params } } = props;
  return <SP {...params} />;
};

SuperReport.propTypes = {
  match: PropTypes.object.isRequired,
};

export default withRouter(SuperReport);



// WEBPACK FOOTER //
// ./src/containers/super-report/index.js